<template>
<el-dialog
       v-model="dialogVisible"
      :append-to-body="false"
      class="custom-service-dialog"
      :show-close="false"
      :style="{ maxWidth: '1200px', width: '90%', background: '#252C3D' }"
      @close="handleClose"
    >
        <img src="@/assets/images/bg/dailog-bg.webp" class="bg">
        <div class="custom-wrapper">
            <!--头部-->
            <div class="header flex justify-between align-center">
                <div class="cumtom-title">{{t('forecast.service')}}</div>
                 <el-icon @click="handleClose"><CloseBold /></el-icon>
            </div>
             <div class="top-bar">
                <span class="location"> <img src="@/assets/images/icon/icon-location.webp" alt="location" />
                  {{locale=="zh-CN"?currentCity?.parent_names:currentCity?.parent_ennames}},{{locale=="zh-CN"?currentCity?.name:currentCity?.enname}}</span>
                <span class="date">{{formatDate(new Date(),locale)}} {{weekDayText}} {{locale=='zh-CN'?'农历'+getLunarDate():''}}</span>
            </div>
            <div class="air-data-num" v-if="aqiData?.aqi"><span class="num">{{ aqiData?.aqi}}</span><span class="level">{{ aqiLevelText }}</span></div>
            <div class="air-data-row">
                <div class="air-data-item" v-if="aqiData?.pm10">
                    <span class="air-data-value">{{ aqiData?.pm10 || '' }}</span>
                    <span class="air-data-label">PM10</span>
                </div>
                <div class="air-data-item" v-if="aqiData?.pm25">
                    <span class="air-data-value">{{ aqiData?.pm25 || '' }}</span>
                    <span class="air-data-label">PM2.5</span>
                </div>
                <div class="air-data-item" v-if="aqiData?.no2">
                <span class="air-data-value">{{ aqiData?.no2 || '' }}</span>
                <span class="air-data-label">NO₂</span>
                </div>
                <div class="air-data-item" v-if="aqiData?.so2">
                <span class="air-data-value">{{ aqiData?.so2 || '' }}</span>
                <span class="air-data-label">SO₂</span>
                </div>
                <div class="air-data-item" v-if="aqiData?.o3">
                <span class="air-data-value">{{ aqiData?.o3 || '' }}</span>
                <span class="air-data-label">O₃</span>
                </div>
                <div class="air-data-item" v-if="aqiData?.co">
                <span class="air-data-value">{{ aqiData?.co || '' }}</span>
                <span class="air-data-label">CO</span>
        </div>
             </div>
             <div class="air-divider"></div>
             <div class="air-publish-date" v-if="aqiData?.pub_time">{{ t("weather.publicDate") }}: {{aqiData?.pub_time || ''}}</div>
        </div>
 </el-dialog>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import { CloseBold } from '@element-plus/icons-vue' // 显式导入图标
import type {WeatherResponse} from '~/types';
import { getAQIInfo,formatDateToChineseMd,getLunarDate,getWeekDay,formatDate} from "@/utils/utils"
import { useI18n } from 'vue-i18n'
const nuxtApp = useNuxtApp()
const {locale, t } = useI18n()
const props = withDefaults(
  defineProps<{
    aqiVisible?: boolean;
    aqiData?: WeatherResponse['aqi'];
    currentCity:any;
  }>(),
  {
    aqiVisible: false,
    aqiData: () => {},
    currentCity:{}
  }
)

const aqiLevelText = computed(() => {
  const aqi = props.aqiData?.aqi
  return aqi != null ? getAQIInfo(+aqi, nuxtApp).text : ''
})

const weekDayText = computed(() => getWeekDay(new Date(), nuxtApp))

// 定义事件
const emit = defineEmits<{
  (e: 'update:aqiVisible', value: boolean): void;
}>()

// 使用计算属性实现双向绑定
const dialogVisible = computed({
  get: () => props.aqiVisible,
  set: (value) => emit('update:aqiVisible', value)
})

// 处理关闭事件
const handleClose = () => {
  emit('update:aqiVisible', false)
}
</script> 
<style scoped lang="scss">
    @use '@/assets/css/airorservice.scss';
</style>